<ng-container *ngIf="displayConflictDescription(currentGroup)">
  <cx-icon [type]="iconTypes.WARNING" aria-hidden="true"></cx-icon>
  {{ currentGroup.name }}
</ng-container>
